const MAX_BYTES = 8 * 1024 * 1024;
const TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];

export async function prepareImage(file) {
  if (!TYPES.includes(file.type)) throw new Error("صيغة الصورة غير مدعومة. اختر JPG أو PNG أو WebP أو GIF.");
  if (file.size <= MAX_BYTES) return file;
  if (file.type === "image/gif") throw new Error("حجم الصورة المتحركة يتجاوز 8 ميغابايت. اختر صورة أصغر.");
  const url = URL.createObjectURL(file);
  try {
    const image = new Image();
    image.src = url;
    await image.decode();
    const scale = Math.min(1, 2048 / Math.max(image.naturalWidth, image.naturalHeight));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
    canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/webp", 0.85));
    if (!blob || blob.size > MAX_BYTES) throw new Error("تعذر تصغير الصورة. اختر صورة أصغر من 8 ميغابايت.");
    return new File([blob], `upload.${blob.type === "image/webp" ? "webp" : "png"}`, { type: blob.type });
  } finally {
    URL.revokeObjectURL(url);
  }
}
